// maybe just ue the cached apollo query questionState results?
//
import { JSX, createContext, useCallback, useState } from 'react';
import { QuestionState } from '@generated/graphql';

export type TripDigestContextType = {
  questionStates: Map<string, QuestionState>;
  setFullQuestionsState: React.Dispatch<React.SetStateAction<Map<string, QuestionState>>>;
  setQuestionState: (state: QuestionState) => void;
  removeQuestionState: (questionId: string) => void;
};

const TripDigestContext = createContext<TripDigestContextType | null>(null);

export interface TripDigestProviderProps {
  children: React.ReactNode;
}

function TripDigestProvider({ children }: TripDigestProviderProps): JSX.Element {
  const [questionStates, setQuestionStates] = useState(new Map<string, QuestionState>());

  // prettier-ignore
  const setFullQuestionsState = useCallback<TripDigestContextType['setFullQuestionsState']>((newState) => {
    setQuestionStates(newState);
  }, []);

  const setQuestionState = useCallback((newState: QuestionState) => {
    // console.log('TripDigestProvider setQuestionState newState: ', newState);
    setQuestionStates((prevState) => new Map(prevState.set(newState.questionId, newState)));
  }, []);

  const removeQuestionState = useCallback((questionId: string) => {
    setQuestionStates((prevState) => {
      prevState.delete(questionId);
      return new Map(prevState);
    });
  }, []);

  return (
    <TripDigestContext.Provider
      value={{
        questionStates,
        setFullQuestionsState,
        setQuestionState,
        removeQuestionState,
      }}
    >
      {children}
    </TripDigestContext.Provider>
  );
}

export default TripDigestProvider;
export { TripDigestContext };
